import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';

import { DebouncedTextArea } from '../../../common/DebouncedTextArea';

function LeadershipText({
  data,
  response,
  onChanged,
}) {
  const items = data.filter(({ type }) => type === 'leadershipText');
  if (items.length === 0) {
    return null;
  }

  return (
    <>
      {items.map((item) => {
        if (
          item.visibilityKey
          && item.visibilityValue
          && response[item.visibilityKey] !== item.visibilityValue
        ) {
          return null;
        }
        return (
          <div key={`leadership-text-${item.key}`}>
            <div className="p-3">{ReactHtmlParser(items[0].content)}</div>
            <DebouncedTextArea
              key={`leadership-text-area-${item.key}`}
              originalValue={response[item.key] || ''}
              scoringKey={item.key}
              onChanged={(key, _id, value) => onChanged({ [key]: value })}
            />
          </div>

        );
      })}
    </>
  );
}

LeadershipText.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  response: PropTypes.object,
  onChanged: PropTypes.func,
};

LeadershipText.defaultProps = {
  data: [],
  response: {},
  onChanged: () => {},
};

export default LeadershipText;
